import styles from "./Styles/TopNav.module.css"
import React from 'react'
import {FiChevronDown} from "react-icons/fi"
import { useLocation } from "react-router-dom"
import navLogo from "../Assets/navLogo.png"
import { HiBell } from "react-icons/hi"
import { BiChevronDown } from "react-icons/bi"

export default function TopNav() {
  const location = useLocation()

  return (
    <nav className={styles.nav}>
      <div className={styles.navLogo}>
        <img src={navLogo} />
      </div>
        <div style={{display:'flex',alignItems:'center',gap:16}}>
          <HiBell color="#299EFE" size={24} />

          <div className={styles.userDropdown}>
            <div>
              <img src="https://img.freepik.com/free-photo/portrait-white-man-isolated_53876-40306.jpg?w=2000" />
              <p>User Name</p>
            </div>
            <BiChevronDown color="#c5c5c5" size={18} />
          </div>
        </div>
    </nav>
  )
}
